import {View} from "react-native";
import LoginComponents from "../../../components/functional-components/LoginComponents";
import Button from "../components/Button";
import TextInput from "../components/TextInput";
import {ColumnSpace} from "../components/_CommonComponents";
import {useContext} from "react";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {Texts} from "../../../texts";
import HeaderPage from "../components/HeaderPage";

export default function Login({navigation}: any) {
    const texts = Texts.instance(useContext(AppConfigContext).lang);
    const appConfig = useContext(AppConfigContext);

    return <HeaderPage title="ورود/عضویت">
        <View style={{flex: 1, padding: 10, flexGrow: 1, justifyContent: "center"}}>

            <LoginComponents>
                <TextInput role="input"/>
                <ColumnSpace/>
                <Button role="main-button"/>
                <ColumnSpace/>
                <Button role="back-button" title={texts.t("login.button_back")}/>
                <Button role="guest-login" title={texts.t("login.button_guest_login")}/>
            </LoginComponents>

        </View>
    </HeaderPage>
}
